import { IBusinessUnits } from "./BusinessUnits";
import { IBrand } from "./brand";
import { ICustomer } from "./Customer";
import { ISubsidiary } from "./Subsidiary";
import { ICustomerRole } from "./CustomerRole";

export interface IUserData {
  data: Array<IUser>;
}

export enum UserTypeTypes {
  "employee" = "Funcionário",
  "customer" = "Cliente",
  "supplier" = "Fornecedor"
}

export enum UserRoleTypes {
  "administrator" = "Administrador",
  "member" = "Colaborador",
  "supplier" = "Colaborador"
}

export enum UserType {
  Unregistered = 0,
  Employee = 1,
  Customer = 2,
  Supplier = 3,
}

export enum PipefyLinkType {
  NoLink = "noLink",
  Member = "member",
  ServiceAccount = "serviceAccount"
}

export enum UserProfileTypes {
  CC_SAC_SERVICE = "Atendimento cc-sac",
  COMMERCIAL_TIME_OF_FIELD = "Comercial time de campo",
  INTERNAL_COMMERCIAL = "Comercial interno",
  CC_LOGISTIC_SERVICE = "Atendimento cc-logística",
  MANUFACTURING_QUALITY = "Qualidade Fábrica",
  MANUFACTURING_QUALITY_TEXTILE = "Qualidade Fábrica Textil",
  MANUFACTURING_QUALITY_EMBRAMED = "Qualidade Fábrica Embramed",
  MANUFACTURING_QUALITY_STICKERS = "Qualidade Fábrica Adesivos",
  FINANCIAL = "Financeiro",
  SHIPPING_COMPANY = "Transportadora",
  SUPERVISOR = "Fiscal",
  DISTRIBUTION_CENTER = "Centro de Distribuição",
  CUSTOMER = "Cliente",
  PHARMACEUTICAL_QUALITY = "Qualidade Farmacêutica",
  RT_QUALITY = "Qualidade RT",
  FREIGHT = "Frete",
  FINANCIAL_BILLING = "Financeiro Cobrança",
  FINANCIAL_BILLS_TO_RECEIVE = "Financeiro Contas a Receber",
  FLEXICOTTON_QUALITY = "Qualidade Flexicotton",
  GROUP_LABS_QUALITY = "Qualidade Grupo Labs",
  SERVICE_MAINTENANCE = "Atendimento Manutenção",
  FW_QUALITY = "Qualidade Feelclean",
  DAVISO_QUALITY = "Qualidade Daviso",
  PFS_QUALITY = "Qualidade Mafra Especialidades",
  SCHEDULING_CENTER = "Central de Agendamento",
  NEVE_QUALITY = "Qualidade Neve",
  DEVOLUTION_SEGREGATED_MANAGEMENT = "Devoluções e Gerenciamento de Segregados",
  OTC_SERVICE = "Atendimento OTC",
  COMMERCIAL_DIRECTOR = "Diretoria Comercial",
  COMMERCIAL_MANAGEMENT = "Gerência Comercial",
  LOSS_APPROVAL = "Aprovador Extravio",
  REVERSE_LOGISTICS = "Logística Reversa",
  COSMETOVIGILANCE_QUALITY = "Qualidade Cosmetovigilância",
  CMH_LENCOS_QUALITY = "Qualidade CMH Lenços",
}

export interface IUser {
  id?: string;
  fullName?: string;
  email?: string;
  phoneNumber?: string;
  roles?: Array<keyof typeof UserRoleTypes>;
  profileType?: Array<keyof typeof UserProfileTypes>;
  whoInvited?: null;
  lastAccess?: null;
  expirationDate?: null;
  userType?: keyof typeof UserTypeTypes;
  enabled?: boolean;
  pending?: boolean;
  userName?: string;
  username?: string;
  customersIds?: Array<string>;
  customerId?: string;
  userWhoInvited?: {
    fullName: string;
  };
  businessUnits?: Array<IBusinessUnits>;
  brands?: Array<IBrand>;
  subsidiaries?: Array<ISubsidiary>;
  sellerId?: string;
  customers?: Array<ICustomer>;
  customer?: ICustomer;
  fileUrl?: string;
  file?: string;
  notViewInitialModal?: boolean;
  selectedCustomerId?: string;
  enterpriseCode?: number;
  madePurchaseIn?: string[];
  customersRoles?: Array<ICustomerRole>;
  deleted?: boolean;
  useElectronicBillLading?: boolean;
  representative?: string;
  isBCGUser?: boolean;
  buBCG?: string;
  supplierId?: string;
  supplierName?: string;
  pipefyLink?: string;
}

export interface DeleteCustomerRoleUserProps {
  userId?: string;
  customerId?: string;
}

export enum EnumUserType {
  EMPLOYEE = "employee",
  CUSTOMER = "customer",
  SUPPLIER = "supplier",
}
